import { DropDownOptions } from 'types/common'

export function isDropdownOptions(value: unknown): value is DropDownOptions[] {
  return !!(value && Array.isArray(value) && value.length > 0 && (value[0] as DropDownOptions).label !== undefined)
}

export function isOptionEqualToValue(
  option: DropDownOptions,
  value: DropDownOptions | string | null | undefined,
): boolean {
  if (typeof value === 'string') {
    return option.label === value || option.value === value
  }
  return option.value === (value as DropDownOptions | null | undefined)?.value
}

export function getFilteredOptions(
  options: DropDownOptions[] | undefined,
  value: unknown,
  multiple: boolean,
): DropDownOptions[] {
  if (multiple && value && isDropdownOptions(value)) {
    return options?.filter((option) => !(value as DropDownOptions[]).some((selected) => selected.value === option.value)) || []
  }
  return options || []
}
